import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TaskDossier\CreateTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/CreateTaskDossierController.php
* @route '/api/task-dossier'
*/
const CreateTaskDossierController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateTaskDossierController.url(options),
    method: 'post',
})

CreateTaskDossierController.definition = {
    methods: ["post"],
    url: '/api/task-dossier',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TaskDossier\CreateTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/CreateTaskDossierController.php
* @route '/api/task-dossier'
*/
CreateTaskDossierController.url = (options?: RouteQueryOptions) => {
    return CreateTaskDossierController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\CreateTaskDossierController::__invoke
* @see app/Http/Controllers/TaskDossier/CreateTaskDossierController.php
* @route '/api/task-dossier'
*/
CreateTaskDossierController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateTaskDossierController.url(options),
    method: 'post',
})

export default CreateTaskDossierController